/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

// Styles
import './styles/LocaleFlag.scss';

const propTypes = {
  changeLocale: PropTypes.func,
  lang: PropTypes.string.isRequired,
  selectedLocale: PropTypes.bool.isRequired,
  flag: PropTypes.string.isRequired,
  langName: PropTypes.string.isRequired,
};

const LocaleFlag = ({ changeLocale, lang, selectedLocale, flag, langName }) => {
  const _onClick = () => {
    if (changeLocale) {
      changeLocale(lang);
    }
  };

  const linkColor = classNames({
    'selected-locale': !!selectedLocale,
    'not-selected-locale': !selectedLocale,
  });

  return (
    <div styleName="LocaleFlag">
      <a href="#" onClick={_onClick} styleName={linkColor}>
        <i
          styleName={selectedLocale ? 'selected-locale' : ''}
          className={`famfamfam-flag-${flag}`}
          style={{ marginRight: 10 }}
        />

        {langName}
      </a>
    </div>
  );
};

LocaleFlag.propTypes = propTypes;

export default LocaleFlag;
